import React, {useEffect} from 'react';
import ContractorDetails from './ContractorDetails';
import ContractorDetailsAdditional from './ContractorDetailsAdditional';
import ContractorBlockInfoRow from '../../layout/ContractorBlockInfoRow';
import WorkType from './WorkType';
import PreviouslyWorkedProjectsSection from './PreviouslyWorkedProjectsSection';
import NotesSection from './NotesSection';

const Content = ({ contractorDetails, profile, toggleModal }) => {
    return (
        <>
            <ContractorDetails contractorDetails={contractorDetails} />
            <ContractorDetailsAdditional contractorDetails={contractorDetails} />
            <ContractorBlockInfoRow
                contractorDetails={contractorDetails}
                isBlockedForCompany={profile.company.blocked_users.includes(contractorDetails.userId)}
                toggleModal={toggleModal}
            />
            <WorkType contractorTools={contractorDetails.tools} />
            <PreviouslyWorkedProjectsSection
                previouslyWorkedProjects={contractorDetails?.previouslyWorkedProjects}
            />
            <div className="content">
                <NotesSection contractorId={contractorDetails.userId} notes={contractorDetails.notes} />
            </div>
        </>
    );
};

export default Content;